<app-center-section>
  @if (!hideTitle) {
    <h1>{{ title }}</h1>
  }
  <div [innerHTML]="body | sanitizeHtml" class="rich-text"></div>
</app-center-section>
@if (strips?.length) {
  <app-strip-container [strips]="strips"></app-strip-container>
}
